import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { injectIntl } from 'react-intl';
import * as Yup from 'yup';
import { searchJobProfile } from '../../../services/apps/JobProfileService';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape, intlShape } from '../../../components/prop-types';
import { growlErrors } from '../../../utils/NotificationUtil';

import EditAssessmentAutoReportForm from './EditAssessmentAutoReportForm';
import { withAccount } from '../../../components/AccountContext';
import { validationMessages } from '../../../i18n/common';

const buildValidationSchema = formatMessage => (
  Yup.object().shape({
    emails: Yup.array()
      .required(formatMessage(validationMessages.required)),
    autogenerateReports: Yup.array()
      .required(formatMessage(validationMessages.required)),
    targetJob: Yup.number()
      .required(formatMessage(validationMessages.required)),
    locale: Yup.string()
      .required(formatMessage(validationMessages.required)),
  })
);

class EditAssessmentAutoReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      jobSearching: false,
    };

    this.searchJob = this.searchJob.bind(this);
  }

  componentDidMount() {
    this.fetchJobs();
  }

  async fetchJobs(query = null) {
    const { assessment, currentAccount, growl } = this.props;
    try {
      this.setState({ jobSearching: true });
      const jobs = await searchJobProfile({
        aid: currentAccount,
        query,
        tempId: assessment.template.id,
      });
      this.setState({
        jobs,
        jobSearching: false,
      });
    } catch (errors) {
      growlErrors(growl, errors);
      this.setState({ jobSearching: false });
    }
  }

  searchJob(query) {
    this.fetchJobs(query);
  }

  render() {
    const {
      activeLocales, saveEditAssessmentAutoReport,
      handleCancel,
      intl: { formatMessage },
      initialValues,
    } = this.props;
    const { jobs, jobSearching } = this.state;
    const validationSchema = buildValidationSchema(formatMessage);
    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values, formikBag) => {
          const { resetForm } = formikBag;
          saveEditAssessmentAutoReport(values);
          resetForm();
        }}
        render={
          formProps => (
            <EditAssessmentAutoReportForm
              formProps={formProps}
              activeLocales={activeLocales}
              jobs={jobs}
              jobSearching={jobSearching}
              searchJob={this.searchJob}
              handleCancel={handleCancel}
            />
          )
        }
      />
    );
  }
}

EditAssessmentAutoReport.propTypes = {
  growl: growlShape.isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  activeLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  saveEditAssessmentAutoReport: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default withAccount(
  withGrowl(
    injectIntl(EditAssessmentAutoReport),
  ),
);
